/**
 * NZSC-3189 — 퍼스트아메리칸 안심 매매 패키지(권원보험) 진입점 게이팅.
 *
 * sherlockSubscriptionAccessHelpers 와 동일 패턴. FA 진입점(매매리포트 발급대기 카드,
 * 등기변동 알리미 배너, 매매리포트 소구 배너, 담당자 의견 카드, 이중매매 특약 등) 노출 제어.
 *
 * 우선순위:
 *   FEATURE_FLAG_ENABLED === true                                 → 전체 오픈(테스터 무시)
 *   INTERNAL_TESTER_ENABLED === true && isInternalTester === true  → 내부 테스터 한정 노출
 *   그 외                                                            → 미노출(옛 UI 유지, 비테스터 영향 0)
 *
 * 풀 오픈 시점: FEATURE_FLAG_ENABLED = true 로 변경(또는 호출처 제거).
 * env 의존 제거 — FE 재배포로 토글(빌드 시점 상수).
 */

/** 단위 테스트용 팩토리. 운영은 아래 바인딩된 fnIsFirstamEnabled 사용. */
export function fnCreateFirstamAccessChecker(featureFlagEnabled, internalTesterEnabled) {
  return function fnIsFirstamEnabledInner(isInternalTester) {
    if (featureFlagEnabled === true) return true;
    if (internalTesterEnabled && isInternalTester === true) return true;
    return false;
  };
}

/**
 * 운영 상수 — 배포 단계별 토글:
 *   1차 prod 배포: FEATURE_FLAG_ENABLED=false + INTERNAL_TESTER_ENABLED=true → 내부 테스터만
 *   풀 오픈:       FEATURE_FLAG_ENABLED=true
 */
const FEATURE_FLAG_ENABLED = true; // 2026-06-17 FA 안심매매패키지 풀오픈(BE FIRSTAM_PUBLIC_OPEN 동반).
const INTERNAL_TESTER_ENABLED = true;

export const fnIsFirstamEnabled = fnCreateFirstamAccessChecker(
  FEATURE_FLAG_ENABLED,
  INTERNAL_TESTER_ENABLED,
);
